export const knowledgeBasePage = {
  heading: 'knowledge-base-page-heading',
  knowledgeBaseTiles: 'knowledge-base-page-tile-link',
};
